import React from 'react';
import { RJSFSchema, UiSchema } from '@rjsf/utils';
import styled from 'styled-components';
import { logger } from 'src/logger';
import { sanitize } from 'isomorphic-dompurify';

const DescriptionArea = styled.div<{ size: DescriptionSize }>`
  font-size: ${({ theme, size }) => {
    switch (size) {
      case 'xs':
        return theme.fontSize.xs;
      case 's':
        return theme.fontSize.s;
      case 'm':
        return theme.fontSize.m;
    }
  }};
`;

type DescriptionSize = 'xs' | 's' | 'm';
export interface IDescriptionWidget {
  size?: DescriptionSize;
  uiSchema: UiSchema<any, RJSFSchema, any> | undefined;
}

interface DescriptionLink {
  text: string;
  href: { [key: string]: string };
}

/**
 * Check the descriptionLink function options.
 * @param uiSchema uiSchema
 * @returns boolean
 */
const getDescriptionLink = (
  uiSchema: UiSchema<any, RJSFSchema, any> | undefined,
): DescriptionLink | undefined => {
  return uiSchema?.['ui:descriptionLink'];
};

const DescriptionContent = (descriptionLink: DescriptionLink): string => {
  let text = descriptionLink.text;
  if (!text) {
    return '';
  }

  const href = descriptionLink.href || {};
  var regexp = new RegExp(Object.keys(href).join('|'), 'gi');
  text = text.replace(regexp, function (matched) {
    return href[matched];
  });
  logger.info(
    `Description Link Generation for ${descriptionLink.text} is: ${text}. Params are`,
    { href },
  );
  return text;
};

export const DescriptionWidget: React.FC<IDescriptionWidget> = ({
  uiSchema,
  size = 's',
}) => {
  const descriptionLink = getDescriptionLink(uiSchema);
  const descriptionContent =
    descriptionLink && DescriptionContent(descriptionLink);
  if (!descriptionContent) {
    return null;
  }

  return (
    <DescriptionArea
      size={size}
      dangerouslySetInnerHTML={{
        __html: sanitize(descriptionContent),
      }}
    ></DescriptionArea>
  );
};
